import { render, staticRenderFns } from "./relatorio-csat.vue?vue&type=template&id=0f819bdf&scoped=true"
import script from "./relatorio-csat.vue?vue&type=script&lang=js"
export * from "./relatorio-csat.vue?vue&type=script&lang=js"
import style0 from "./relatorio-csat.vue?vue&type=style&index=0&id=0f819bdf&prod&lang=css"
import style1 from "./relatorio-csat.vue?vue&type=style&index=1&id=0f819bdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f819bdf",
  null
  
)

export default component.exports